import React from "react";
import Select from "react-select";
import { ButtonGroup, Button, Icon } from "aible";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faEyeSlash, faCog, faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";

import styles from "./style.module.css";

import { LineInput } from "components/Inputs/LineInput";

import { STEP_TYPE, WIZARD_SECTIONS } from "containers/Wizard/reducer";
import { PROJECT_MODES, PANEL_MODES } from "containers/Run/reducer";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import ProgressIndicator from "components/CreateWizard/Utils/ProgressIndicator";
import BlankUseCaseTile from "components/UnifiedProject/SelectData/BlankUseCaseTile";

import blueprintWhiteIcon from "images/tileIcons/blueprint_white.svg";

import BlueprintViewContainer from "containers/View/Blueprint";
import BlueprintItemContainer from "containers/View/Item/BlueprintItem";

import MadLibsBoxContainer from "containers/Business/ModelBox/MadLibsBox";

export default class SelectDataWrapper extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectBlueprint: false
    };
  }

  renderAdvanced() {
    const {
      isAdvanced,
      isEditBlueprint,
      name,
      index,
      isWizardShow,
      isCurrentStep,
      type,
      removeStep,
      stepLength,
      incrementStep,
      increasePriority,
      decreasePriority,
      options,
      updateOption,
      isNextEnabled,
      isCreating,
      nextName,
      hasNext,
      isHover,
      stepNum,
      stepTotal,
      stepSize,
      children,
      datasetId,
      hideNext,
      showBlueprintCreate,
      updateIsEditing,
      blueprint,
      trainAI,
      isNext,
      selectedDataset
    } = this.props;

    const isLocked = options && options["lock"];
    const isHidden = options && options["hide"];

    return (
      <div>
        <div className={styles.datasetPicker} style={{ marginTop: "30px" }}>
          {isEditBlueprint ? (
            <div>
              <div className={styles.bBold}>
                {"What dataset would you like to use as the example users should map to?"}
              </div>
              <div className={styles.infoBox}>
                {"This will populate the fields that users will map datasets to in order to train their models."}
              </div>
            </div>
          ) : (
            <div>
              <div className={styles.bBold}>{"Your Selected Data"}</div>
            </div>
          )}
        </div>
        <div
          className={
            styles.wizardStepHolder +
            " " +
            (isWizardShow || true ? styles.wizardStepShow : "") +
            " " +
            (options && options["hide"] === true ? styles.wizardHidden : "") +
            " " +
            (type === STEP_TYPE.CHOOSE_DATASET.id ? "chooseDataset" : "")
          }
        >
          <div
            className={
              styles.wizardStep + " " + (isHover ? styles.hoverStep : "") + " " + (isNext ? styles.nextStep : "")
            }
          >
            <div className={styles.wizardStepContent}>{children}</div>
          </div>
        </div>
      </div>
    );
  }

  getIsCategorical(dataset) {
    return (
      dataset &&
      dataset.outcome &&
      dataset.fields &&
      dataset.fields[dataset.outcome] &&
      dataset.fields[dataset.outcome].type === "categorical"
    );
  }

  getIsNumerical(dataset) {
    return (
      dataset &&
      dataset.outcome &&
      dataset.fields &&
      dataset.fields[dataset.outcome] &&
      dataset.fields[dataset.outcome].type === "number"
    );
  }

  renderEditBlueprintTile() {
    const { blueprint, updateLabel, updateDescription, bpDescription, setup } = this.props;

    return (
      <div className={styles.editBpTileWrapper}>
        <div style={{ fontWeight: "bold", marginTop: "20px" }}>{"Blueprint Name"}</div>
        <div className={styles.editBpTile}>
          <div className={styles.editBpHeader}>
            <img src={blueprintWhiteIcon} className={styles.bpIcon} />
            <div style={{ width: "calc(100% -  20px)" }}>
              <LineInput
                isEditable
                showRight
                defaultValue={
                  blueprint && blueprint.name ? blueprint.name : setup && setup.label ? setup.label : "New Blueprint"
                }
                value={setup && setup.label ? setup.label : blueprint && blueprint.name ? blueprint.name : undefined}
                onChange={(val) => updateLabel(val)}
                style={{
                  width: "calc(100% - 20px)",
                  margin: "0px 20px 0px 10px"
                }}
                inputStyle={{ background: "#FFFFFF" }}
              />
            </div>
          </div>
          <div className={styles.editBpDesc}>
            <div>{"Add a description"}</div>
            <textarea
              className={styles.editBpDescBox}
              defaultValue={
                blueprint && blueprint.wizard && blueprint.wizard.description
                  ? blueprint.wizard.description
                  : setup && setup.description
                    ? setup.description
                    : ""
              }
              onBlur={(event) => updateDescription(event.target.value)}
            ></textarea>
          </div>
        </div>
      </div>
    );
  }

  renderBlueprintPicker() {
    const {
      id,
      optimized,
      isEditBlueprint,
      isBlueprintPicker,
      updateIsEditBlueprint,
      blueprint,
      blueprints,
      updateBlueprintId,
      projectId,
      dataset
    } = this.props;

    const { selectBlueprint } = this.state;

    return (
      <div className={styles.blueprintPicker}>
        {isEditBlueprint ? (
          <div>
            <div className={styles.bBold}>{"Edit the Blueprint's Name and Description"}</div>
            <div className={styles.infoBox}>{"This helps users choose the appropriate blueprint."}</div>
          </div>
        ) : (
          <div>
            <div className={styles.bBold}>{"Your Business Problem"}</div>
            <div className={styles.infoBox}>
              {"This frames the project in a business context, and allows Aible to appropriately optimize the outcome."}
            </div>
          </div>
        )}
        {isEditBlueprint ? (
          <div className={isBlueprintPicker ? styles.bpSelectedWrapperBp : styles.bpSelectedWrapper}>
            {this.renderEditBlueprintTile()}
            <MadLibsBoxContainer {...this.props} id={id} optimized={optimized} forceShow />
          </div>
        ) : blueprint !== undefined || selectBlueprint === false ? (
          <div className={isBlueprintPicker ? styles.bpSelectedWrapperBp : styles.bpSelectedWrapper}>
            <div className={styles.bSelected}>
              {blueprint !== undefined ? <BlueprintItemContainer id={blueprint.id} noClick /> : <BlankUseCaseTile />}
              <Button
                onClick={() => {
                  updateBlueprintId(undefined, projectId);
                  this.setState({ selectBlueprint: true });
                }}
              >
                {"Change"}
              </Button>
            </div>
            <MadLibsBoxContainer {...this.props} id={id} optimized={optimized} />
          </div>
        ) : (
          <div className={styles.bList}>
            {/* <div
              className={styles.emptyBpTile}
            >
              <div style={{ fontWeight: "bold" }}>
                {"No Blueprint Selected"}
              </div>
              <div>
                {
                  "Apply one at any point to add business context to this project."
                }
              </div>
            </div> */}
            <BlueprintViewContainer
              isMini
              isCategorical={this.getIsCategorical(dataset)}
              isNumerical={this.getIsNumerical(dataset)}
              onClick={(blueprintId) => {
                updateBlueprintId(blueprintId, projectId);
                this.setState({ selectBlueprint: false });
              }}
              onEditClick={(blueprintId) => {
                updateBlueprintId(blueprintId, projectId);
                updateIsEditBlueprint(true);
                this.setState({ selectBlueprint: false });
              }}
              firstTile={
                <BlankUseCaseTile
                  onClick={() => {
                    updateBlueprintId(undefined, projectId);
                    this.setState({ selectBlueprint: false });
                  }}
                />
              }
            />
          </div>
        )}
      </div>
    );
  }

  render() {
    const {
      id,
      optimized,
      isAdvanced,
      isEditBlueprint,
      isHeader,
      index,
      type,
      removeStep,
      incrementStep,
      isNextEnabled,
      isModelsNext,
      isWizardShow,
      isCurrentStep,
      hideBlueprint,
      isBlueprintPicker,
      hasNext,
      nextName,
      children
    } = this.props;

    if (isHeader) {
      return <SelectDataHeader {...this.props} />;
    }

    if (id === "new" && type === STEP_TYPE.SUCCESS.id && isWizardShow && isEditBlueprint === false) {
      return <LoadingIndicator />;
    }

    return (
      <div className={styles.sData} style={isModelsNext ? { width: "560px" } : {}}>
        <div className={styles.sDataWrap}>
          {hideBlueprint !== true || (isBlueprintPicker && this.renderBlueprintPicker())}
          {isBlueprintPicker !== true && <div>{this.renderAdvanced()}</div>}
        </div>
      </div>
    );
  }
}

class SelectDataHeader extends React.PureComponent {
  render() {
    const {
      isAdvanced,
      isEditBlueprint,
      style,
      name,
      index,
      isWizardShow,
      isCurrentStep,
      isStep,
      type,
      removeStep,
      stepLength,
      incrementStep,
      isEmptyModel,
      increasePriority,
      decreasePriority,
      options,
      updateOption,
      isNextEnabled,
      nextName,
      hasNext,
      projectId,
      history,
      isHover,
      stepNum,
      title,
      stepTotal,
      stepSize,
      id,
      tabs,
      hideTabs,
      checkIsEnabledTab,
      runCost,
      estimatedRunCost,
      isRunning,
      hasModels,
      notebookProgress,
      children,
      handleCancel,
      errors,
      isQuickRun,
      panelMode,
      updatePanelMode
    } = this.props;

    const isLocked = options && options["lock"];
    const isHidden = options && options["hide"];
    const selectedTab = options && options["selectedTab"];

    const errorOnStep = errors && errors.length && type == STEP_TYPE.ACADEMIC_SUCCESS.id; //only surfacing errors here

    return errorOnStep ? (
      <div className={styles.wizardStepHeader} style={style ? { ...style } : {}}>
        <Icon type={"times"} size={24} isRound background={"red"} />
        <div style={{ marginLeft: "10px" }}>
          AI Modeling Failed {/*I need title codes in the error metadata, which Is not being passed yet */}
        </div>
      </div>
    ) : (
      <div className={styles.wizardStepHeader} style={style ? { ...style } : {}}>
        {tabs && (type !== STEP_TYPE.SUCCESS.id || isEmptyModel !== true) && (
          <div className={styles.tabHolder} style={{ marginLeft: "20px" }}>
            <ButtonGroup>
              {Object.keys(tabs)
                .filter((key) => checkIsEnabledTab(key, tabs[key]))
                .map((s, i) => (
                  <Button
                    type="secondary"
                    key={tabs[s]}
                    active={selectedTab === tabs[s] || (selectedTab === undefined && i === 0)}
                    onClick={() => updateOption("selectedTab", tabs[s])}
                  >
                    {tabs[s]}
                  </Button>
                ))}
            </ButtonGroup>
          </div>
        )}
        <div style={{ flexGrow: 1 }} />
        {isEditBlueprint === true && isAdvanced && (
          <div className={styles.actionHolder} style={{ marginLet: "20px" }}>
            <ButtonGroup>
              <Button
                type="secondary"
                onClick={() => increasePriority(index)}
                disabled={index === 0}
                title={"Move Step Up"}
              >
                <FontAwesomeIcon icon={faChevronUp} />
              </Button>
              <Button
                type="secondary"
                onClick={() => decreasePriority(index)}
                disabled={index === stepLength - 1}
                title={"Move Step Down"}
              >
                <FontAwesomeIcon icon={faChevronDown} />
              </Button>
              <Button
                type="secondary"
                onClick={() => updateOption("lock", options ? !options["lock"] : true)}
                active={options && options["lock"] === true}
                title={"Lock User Input"}
              >
                <FontAwesomeIcon icon={faLock} />
              </Button>
              <Button
                type="secondary"
                onClick={() => updateOption("hide", options ? !options["hide"] : true)}
                active={options && options["hide"] === true}
                title={"Hide Step"}
              >
                <FontAwesomeIcon icon={faEyeSlash} />
              </Button>

              {/*
                  <Button
                    type="secondary"
                    onClick={() => updateOption("showOptions", options ? !options["showOptions"] : true)}
                    active={options && options["showOptions"] === true}
                  >
                    <FontAwesomeIcon icon={faCog} />
                  </Button>
                  */}
              <Button type="secondary" onClick={() => removeStep()}>
                {"Remove Step"}
              </Button>
            </ButtonGroup>
          </div>
        )}
        {id !== "new" && (type === STEP_TYPE.SUCCESS.id || type === STEP_TYPE.ACADEMIC_SUCCESS.id) && (
          <div className={styles.spendHolder}>
            {isRunning ? (
              <div className={styles.runningMessages}>
                {!hasModels ? <StatusMessage isComplete>{"Server Started"}</StatusMessage> : ""}
                {!hasModels ? (
                  <StatusMessage style={{ marginLeft: "15px" }} isComplete={notebookProgress >= 100}>
                    {"Notebooks Created"}
                  </StatusMessage>
                ) : (
                  ""
                )}
                <LoadingIndicator style={{ margin: "0px", transform: "scale(.5)" }} />
                <Button style={{ marginRight: "10px" }} type="secondary" onClick={handleCancel}>
                  Cancel Run
                </Button>
              </div>
            ) : (
              ""
            )}
            <div className={styles.spentMessage}>
              {runCost && !isNaN(runCost) ? "Total Spent: " : "Estimated Cost: "}
              <span className={styles.spendMessage}>
                {runCost && !isNaN(runCost)
                  ? "$" + Math.max(runCost).toFixed(2)
                  : !isNaN(estimatedRunCost)
                    ? "$" + estimatedRunCost.toFixed(2)
                    : "Calculating..."}
              </span>
            </div>
          </div>
        )}
      </div>
    );
  }
}

class StatusMessage extends React.PureComponent {
  render() {
    const { isComplete, style } = this.props;
    return (
      <div className={styles.statusMessage} style={{ ...style }}>
        <span>{this.props.children}</span>
        <div className={styles.statusCircle + (isComplete ? " " + styles.statusComplete : "")} />
      </div>
    );
  }
}
